export const accountancyEntry = {
  null: 'Non spécifié',
  1: 'Par le cabinet',
  2: 'Par le client',
  3: 'Externalisé',
};

export const consultationType = {
  null: 'Non spécifié',
  1: 'Physique',
  2: 'Visioconférence',
};

export const nbConsultations = {
  1: 'Mensuel',
  2: 'Trimestriel',
  3: 'Intermédiaire',
  4: 'Annuel',
};

export const revenue = {
  1: 'Moins de 100 000€',
  2: '100 000 à 500 000€',
  3: "500 000 à 3 Millions d'€",
  4: "Plus de 3 Millions d'€",
};

export const nbInvoices = {
  1: 'Moins de 200',
  2: '200 à 500',
  3: '500 à 1500',
  4: '1500 à 3000',
  5: 'Plus de 3000',
};

export const avoidActivities = ['Discount', 'Markup'];

export const manualActivities = [
  'VSE Full Service',
  'Tax Optimization',
  'Consulting for companies in difficulty',
  'Market research',
  'Business valuation',
  'Outsourced CFO',
  'CSR',
  'Consolidation',
  'Mergers & Acquisitions',
  'Company buyouts',
  'Company tranfers',
];
